import React, { Component } from "react";
import { connect } from "react-redux";
import GeneralDetail from "../GeneralDetail/GeneralDetail";
import AccountHistory from "../AccountHistory/accountHistory";
import LoginHistory from "../LoginHistory/loginHistory";
import PaymentHistory from "../paymentHistory/paymentHistory";
import BettingHistory from "../BettingHistory/bettingHistory";
import Bonus from "../Bonuses/Bonus";
import Notes from "../AddNote/addNote";
import Tags from "../Tags/Tags";
import BankDetails from "../BankDetails/Bankdetails";
import BonusTransaction from "../BonusTransaction/BonusTransaction";
import FraudScrub from "../FraudScrub/FraudScrub";
import { PrimaryPlayerData } from "../Common/PrimaryplayerTab/ComTab";
import ResponsibleGambling from "../ResponsibleGambling/ResponsibleGambling";
import LimitsTab from "../PaymentLimitTab/LimitsTab";
// import UserStake from "../UserStakeSetting/UserStake"; // commented out - stake/preference API disabled per request
import KycDocumemts from "../KYCDocuments/KycDocumemts";
import PlayerInsights from "../PlayerInsights/PlayerInsights";

// Module-level so it survives this component unmounting/remounting (e.g.
// switching away to another top-level app tab and back), not tied to any
// one instance - keeps the tab strip's horizontal scroll position instead
// of it resetting to the left on remount.
let savedTabStripScrollLeft = 0;

class PrimaryTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "generaldetail",
      gamblingTab: false,
      bankDetailsTab: false,
      kycDocuments: false,
      paymentHistory: false,
      playerInsights: false,
      primaryFilteredPlayerData: [],
    };
    this.tabStripRef = React.createRef();
    this.handleTabStripScroll = () => {
      savedTabStripScrollLeft = this.tabStripRef.current.scrollLeft;
    };
  }

  handleTabClickChange = (tab) => {
    sessionStorage.setItem("PrimaryTabsActiveTab", tab);

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("tab", tab);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, "", newUrl);

    this.setState({ activeTab: tab });
  };

  filterTabs = (gamblingTab, bankDetailsTab, kycDocuments, paymentHistory, playerInsights) => {
    return PrimaryPlayerData.filter((tab) => {
      if (!gamblingTab && tab.id === 12) return false;
      if (!bankDetailsTab && tab.id === 2) return false;
      if (!kycDocuments && tab.id === 15) return false;
      if (!paymentHistory && tab.id === 4) return false;
      if (!playerInsights && tab.id === 16) return false;
      if (tab.id === 14) return false; // User Stakes tab hidden - stake/preference API disabled per request
      return true;
    });
  };

  componentDidMount() {
    window.addEventListener("popstate", this.syncTabWithUrl);
    this.syncTabWithUrl();

    const el = this.tabStripRef.current;
    const applyTabStripScroll = () => { el.scrollLeft = savedTabStripScrollLeft; };
    applyTabStripScroll();
    el.addEventListener("scroll", this.handleTabStripScroll);

    // The tab buttons populate a moment later via syncTabWithUrl's setState
    // (this.state.primaryFilteredPlayerData starts empty), so the strip
    // isn't scrollable yet on the assignment above - keep reapplying while
    // it grows to its real width, instead of a one-shot assignment that gets
    // clamped to 0 and stays there.
    this.tabStripResizeObserver = new ResizeObserver(applyTabStripScroll);
    this.tabStripResizeObserver.observe(el);
    this.tabStripSettleTimeout = setTimeout(() => this.tabStripResizeObserver.disconnect(), 800);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.syncTabWithUrl);
    this.tabStripRef.current?.removeEventListener("scroll", this.handleTabStripScroll);
    this.tabStripResizeObserver?.disconnect();
    clearTimeout(this.tabStripSettleTimeout);
    this.tabStripRef.current?.removeEventListener("scroll", this.handleTabStripScroll);
  }

  syncTabWithUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    let initialTab = searchParams.get("tab");

    const saved = sessionStorage.getItem("PrimaryTabsActiveTab");
    if (!initialTab && saved) {
      initialTab = saved;
      searchParams.set("tab", initialTab)
      window.history.replaceState({}, "", `${window.location.pathname}?${searchParams.toString()}`);
    }

    if (!initialTab) {
      initialTab = "generaldetail";
    }

    const gamblingTab = localStorage.getItem("Gambling") === "ADMIN_RESPONSIBLE_GAMBLING";
    const bankDetailsTab = localStorage.getItem("bankDetails") === "ADMIN_BANK_DETAILS";
    const kycDocuments = localStorage.getItem("KYCDocumentDetails") === "ADMIN_KYC_DOCUMENTS";
    const paymentHistory = localStorage.getItem("PaymentHistory") === "ADMIN_PAYMENT_HISTORY";
    const playerInsights = localStorage.getItem("PlayerInsights") === "ADMIN_PLAYER_INSIGHTS";

    const data = this.filterTabs(gamblingTab, bankDetailsTab, kycDocuments, paymentHistory, playerInsights);

    const allowedValues = data.map((t) => t.value);
    if (!allowedValues.includes(initialTab)) {
      const fallback = data.length > 0 ? data[0].value : "generaldetail";
      initialTab = fallback;
      sessionStorage.setItem("PrimaryTabsActiveTab", fallback);
      searchParams.set("tab", fallback);
      window.history.replaceState({}, "", `${window.location.pathname}?${searchParams.toString()}`);
    }

    this.setState({
      activeTab: initialTab,
      gamblingTab,
      bankDetailsTab,
      kycDocuments,
      paymentHistory,
      playerInsights,
      primaryFilteredPlayerData: data,
    });
  };

  render() {
    const { activeTab } = this.state;

    // Both overflow classes on the card below, deliberately. overflow-hidden
    // makes the card a scroll container, which stops position:sticky working
    // for anything a tab renders inside it (the Player Insights header and
    // anchor nav); overflow-clip clips identically without doing that.
    // Tailwind emits .overflow-clip after .overflow-hidden, so browsers that
    // support clip take it, and older ones (iOS Safari < 16, still in our
    // browserslist targets) drop the unknown value and keep hidden - i.e. the
    // exact behaviour they have today.
    return (
      <div className="rounded-lg border bg-card shadow-sm overflow-hidden overflow-clip">
        {/* Tabs Navigation */}
        <div className="border-b bg-muted/50">
          <div ref={this.tabStripRef} className="flex overflow-x-auto scrollbar-thin">
            {this.state.primaryFilteredPlayerData.map((items) => (
              <button
                key={items.id}
                onClick={() => this.handleTabClickChange(items.value)}
                className={`px-6 py-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === items.value
                    ? "border-b-2 border-primary bg-background text-foreground"
                    : "text-muted-foreground hover:text-foreground hover:bg-background/50"
                  }`}
              >
                {items.title}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === "generaldetail" ? (
            <GeneralDetail />
          ) : activeTab === "accounthistory" ? (
            <AccountHistory />
          ) : activeTab === "loginhistory" ? (
            <LoginHistory />
          ) : activeTab === "bankdetails" && this.state.bankDetailsTab ? (
            <BankDetails />
          ) : activeTab === "payment" && this.state.paymentHistory ? (
            <PaymentHistory />
          ) : activeTab === "betting" ? (
            <BettingHistory />
          ) : activeTab === "bonuses" ? (
            <Bonus />
          ) : activeTab === "bonusTransaction" ? (
            <BonusTransaction />
          ) : activeTab === "tags" ? (
            <Tags />
          ) : activeTab === "notes" ? (
            <Notes />
          ) : activeTab === "fraudScrub" ? (
            <FraudScrub />
          ) : activeTab === "responsibleGambling" && this.state.gamblingTab ? (
            <ResponsibleGambling />
          ) : activeTab === "playerLimits" ? (
            <LimitsTab />
          ) : /* activeTab === "userStakes" ? (
            <UserStake />
          ) : */ activeTab === "kycDocuments" && this.state.kycDocuments ? (
            <KycDocumemts />
          ) : activeTab === "playerInsights" && this.state.playerInsights ? (
            <PlayerInsights />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps)(PrimaryTabs);